import { Layout } from "antd";
import SideBar from "../SideBar";
import Nav from "../Nav";
import { useSelector } from "react-redux";
import { roleIds } from "../../constant";
import Footer from "./Footer";
import ScrollToTop from "../../common/ScrollToTop";
const { Content } = Layout;

const contentStyle = {
  textAlign: "center",
  minHeight: "fit-content",
  // lineHeight: "120px",
  color: "#fff",
  marginBottom: 40,
};

const layoutStyle = {
  borderRadius: 8,
  overflow: "hidden",
  width: "calc(100% - 5px)",
  maxWidth: "calc(100% - 5px)",
  height: "100vh",
  background: "#F5F5F5",
};

const innerLayout = {
  overflowY: "auto",
};

const MainLayout = ({ title, description, backButton, children }) => {
  const { is_customer } = useSelector((state) => state.auth);

  return (
    <>
      <Layout style={layoutStyle} className="layoutbg">
        {is_customer ? null : <SideBar />}
        <Layout style={innerLayout} className="scrollable-content">
          <Nav title={title} description={description} backButton={backButton} />
          <Content style={contentStyle} className="px-10 py-2">
            {children}
          </Content>
          {is_customer && (
            <>
              <Footer></Footer>
              <ScrollToTop></ScrollToTop>
            </>
          )}
        </Layout>
      </Layout>
    </>
  );
};

export default MainLayout;
